<template>
  <div id="search">
    <p class="title">协议库搜索</p>
    <el-form
      :inline="true"
      :model="searchForm"
      class="searchForm"
      size="mini"
    >
      <el-form-item>
        <el-input
          style="width: 50vw"
          v-model="searchForm.searchValue"
          placeholder="请输入关键字"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="search"
        >查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tableBox">
      <el-table
        :data="table.data"
        border
        height="100%"
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: '#2c86d1',
          color: 'white',
          textAlign: 'center',
        }"
        :cell-style="{ textAlign: 'center' }"
        v-loading="table.loading"
      >
        <el-table-column
          prop="ProtocolCode"
          label="模板编码"
          width="240"
           :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="ProtocolName"
          label="名称"
          width="120"
           :show-overflow-tooltip="true"
        > </el-table-column>
        <el-table-column
          prop="CompName"
          label="公司名称"
          width="200"
           :show-overflow-tooltip="true"
        > </el-table-column>
        <el-table-column
          prop="ProductUse"
          label="适用型号"
           :show-overflow-tooltip="true"
        > </el-table-column>
        <el-table-column
          prop="Remark"
          label="模板说明"
           :show-overflow-tooltip="true"
        > </el-table-column>
        <el-table-column
          prop="CreateUserName"
          label="制作者"
           :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="UpdateTime"
          label="更新时间"
          width="200"
           :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              @click="handleConfig(scope.row)"
            >配置协议</el-button>
            <el-button
              size="mini"
              type="primary"
              @click="getDown(scope.row.ProtocolID)"
            >下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 配置协议 -->
    <el-dialog
      :title="modalTitle"
      :visible.sync="configFlag"
      top="6vh"
      width="90%"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="遥测点表"
          name="second"
        >
          <Telemetry
            :item="TempVerID"
            :power="power"
            :Value="Value"
          />
        </el-tab-pane>
        <el-tab-pane
          label="遥信点表"
          name="first"
        >
          <Remote
            :item="TempVerID"
            :power="power"
            :Value="Value"
          />
        </el-tab-pane>
        <el-tab-pane
          label="遥控点表"
          name="three"
        >
          <Telecontrol
            :item="TempVerID"
            :power="power"
            :Value="Value"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { getParams } from "@/utils/common";
import { mapGetters } from "vuex";
import Telemetry from "../protocol/component/Telemetry";
import Remote from "../protocol/component/remote";
import Telecontrol from "../protocol/component/telecontrol";
export default {
  components: {
    Telemetry,
    Remote,
    Telecontrol,
  },
  data() {
    return {
      loginLoading: false,
      searchForm: {},
      TempVerID: "",
      configFlag: false,
      modalTitle: "",
      activeName: "second",
      power: "",
      Value: {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.",
      },
      table: {
        data: [],
        loading: false,
      },
    };
  },
  computed: {
    ...mapGetters(["SessionId", "UserId"]),
  },

  methods: {
    getDown(id) {
      this.$messageBox
        .confirm("确定要覆盖所选的配置表吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          console.log("确定要覆盖所选的配置表吗");
          this.download(id);
        })
        .catch(() => {});
    },
    async download(id) {
      let type = getParams("type") ? getParams("type") : 1;
      let obj = {
        ClientName: "Hoko.Iot.Web.",
        Params: {
          ClientType: 1,
          ProtocolID: id,
          ProType: type,
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.downloadProtocolList,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        console.log(res);
        window.parent.postMessage(
          {
            type: "protocol",
            code: "success",
            data: res.ReturnList,
          },
          "*"
        );
      } else {
        this.$message.error(res.Error);
      }
    },
    // 配置协议
    // 点表配置
    handleConfig(item) {
      this.modalTitle = "点表配置";
      this.configFlag = true;
      // 传给子界面的参数
      this.TempVerID = item.ProtocolID;
      this.power = item.Status;
    },
    async getList(searchValue) {
      this.table.loading = true;
      let obj = {
        ClientName: "Hoko.Iot.Web.User",
        Params: {},
      };
      if (searchValue) {
        obj.Params.SearchValue = this.searchForm.searchValue;
      }
      const res = await this.$api.axios_http(
        this.$gd.GetProtocolList,
        obj,
        "POST"
      );
      this.table.loading = false;
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          res.ReturnList.forEach((item) => {
            if (item.UpdateTime) {
              item.UpdateTime = this.$moment(item.UpdateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        this.table.data = res.ReturnList;
        console.log(res);
      } else {
        this.$message.error(res.Error);
      }
    },
    async search() {
      this.getList(this.searchForm.searchValue);
      // window.parent.postMessage(
      //   {
      //     data: {
      //       code: "success",
      //       test: `我是子页面数据${this.searchForm.searchValue}`,
      //     },
      //   },
      //   "*"
      // );
    },
    handleClickMessage(event) {
      const data = event.data;
      console.log(data);
    },
  },
  mounted() {
    console.log(getParams("type"));
    this.getList();
    window.addEventListener("message", this.handleClickMessage);
  },
};
</script>
<style lang="scss" scoped>
#search {
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
  overflow: hidden;
  .title {
    font-size: 28px;
    margin: 0;
    margin-bottom: 22px;
  }
  .tableBox {
    flex: 1;
    width: 100%;
  }
}
</style>
